"use client";
import { cn } from "@/lib/utils";
import type { EvidenceItem } from "../../data";
import { useEvidenceFilter } from "../../hooks";
import EvidenceTag, {
  evidenceBorderClass,
} from "../evidenceTag/evidenceTag.component";

interface EvidenceCardProps {
  item: EvidenceItem;
  label: string;
}

// One labelled claim. Dims when the page filter picks another label.
const EvidenceCard = ({ item, label }: EvidenceCardProps) => {
  const { show } = useEvidenceFilter();
  const isDimmed = show !== "all" && show !== item.kind;

  return (
    <article
      className={cn(
        "grid content-start gap-2 rounded-[26px] border-t-[6px] bg-white px-[22px] pt-[22px] pb-[18px] shadow-card transition-[opacity,transform] duration-300 motion-reduce:transition-none",
        evidenceBorderClass[item.kind],
        isDimmed && "scale-[0.985] opacity-55",
      )}
    >
      <EvidenceTag kind={item.kind} label={label} />
      <p className="text-[1.1rem] leading-[1.3] font-extrabold text-ink">
        {item.title}
      </p>
      <p className="text-[15.5px] leading-normal text-ink">{item.text}</p>
      <p className="grid gap-0.5 text-[12.5px] text-ink-muted">
        <span>{item.source}</span>
        {item.meta && <span>{item.meta}</span>}
      </p>
    </article>
  );
};

export default EvidenceCard;
